import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AbstractDynamicComponent } from '@components/abstracts';
import { ListingPlansDeTravail } from '@components/listing-plans-de-travail/models';
import { FilterToggleGroupComponent } from '@shared/components/filter-toggle-group';
import { GridSkeletonComponent } from '@shared/components/grid-skeleton';
import { Image } from '@shared/components/image/models';
import { OptionCardComponent } from '@shared/components/option-card';
import { PopinImageComponent } from '@shared/components/popin-image';
import { TitleComponent } from '@shared/components/title';
import { DialogService } from '@shared/services/dialog';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { UrlParamsService } from '@shared/services/url-params';
import { filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-listing-plans-de-travail',
  imports: [FilterToggleGroupComponent, GridSkeletonComponent, OptionCardComponent, TitleComponent, NgTemplateOutlet],
  templateUrl: './listing-plans-de-travail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListingPlansDeTravailComponent extends AbstractDynamicComponent<ListingPlansDeTravail> {
  protected readonly filterName = 'filter_countertop_texture';
  private readonly filtersUrlParam = inject(UrlParamsService).param(this.filterName);
  private readonly dialogService = inject(DialogService);
  private readonly elasticSearchService = inject(ElasticSearchService);
  protected readonly countertops = toSignal(
    toObservable(this.filtersUrlParam).pipe(
      filter((param): param is string => !!param),
      switchMap((param) => this.elasticSearchService.getCountertops(param.split('__')))
    )
  );
  protected readonly filters = toSignal(this.elasticSearchService.getCountertopsFilter());

  openVisualFullScreenModal(image: Image): void {
    this.dialogService.openDialog(PopinImageComponent, 'FULL_SCREEN', {
      data: {
        image,
      },
    });
  }
}
